
<div
  v-show="open"
  class="right-click-menu"
  :style="style"
  @mouseover.stop="highlightMyTarget(target)"
>
  <div
    v-for="(action, idx) in actions"
    :key="action.label + idx"
    class="right-click-menu__option"
    @click.prevent.stop="execute(action)"
  >
    {{ action.label }}
    <i
      class="material-icons"
      v-text="action.icon"
    />
  </div>
</div>
